import React from 'react';
import PageTitle from 'modules/common/components/PageTitle';
import { IconPencil } from 'modules/common/icons';
import { removeEmpty, storage, replaceAllString } from 'modules/common/helper';
import { Button } from 'modules/common/input';
import { omit } from 'lodash';
import { useHistory } from 'react-router-dom';
import DetailsView from './components/DetailsView';
import { useRegister } from './hooks';

const editReturnLink = (title, callback) => (
  <div className="flex items-center gap-4">
    <button
      type="button"
      onClick={callback}
      className="btn primary sm rounded-full w-8 h-8"
    >
      <IconPencil className="text-white h-4 w-4" />
    </button>
    <span className="text-primary-500 font-medium">{title}</span>
  </div>
);

function ReviewDetails() {
  const [isRegisterApiLoading, register] = useRegister();
  // eslint-disable-next-line no-underscore-dangle
  const _personal = storage.get('personal') ? storage.get('personal') : {};
  const personal = omit(_personal, ['password', 'password_confirmation']);

  // eslint-disable-next-line no-underscore-dangle
  const _address = storage.get('address')
    ? storage.get('address')?.address
    : {};

  const address = Object.assign(
    {},
    ...Object.keys(_address).map((k) => ({
      [k]: typeof _address[k] === 'object' ? _address[k]?.label : _address[k],
    }))
  );

  const photo = storage.get('photo') ? storage.get('photo')?.photo : '';

  const history = useHistory();
  const onClick = (link) => () => {
    history.push({
      pathname: link,
      state: {
        is_edit: true,
      },
    });
  };

  const handleOnRegister = (e) => {
    e.preventDefault();
    const regEx = /[()\s]/g;
    const args = {
      last_name: _personal?.last_name ?? '',
      first_name: _personal?.first_name ?? '',
      middle_name: _personal?.middle_name ?? '',
      birth_date: _personal?.birth_date ?? '',
      email: _personal?.email ?? '',
      mobile_number: replaceAllString(_personal?.mobile_number, regEx),
      password: _personal?.password ?? '',
      password_confirmation: _personal?.password_confirmation ?? '',
      region_code: _address?.region?.value ?? '',
      province_code: _address?.province?.value ?? '',
      municipality_code: _address?.municipality?.value ?? '',
      barangay_code: _address?.barangay?.value ?? '',
      street: _address?.full_address ?? '',
      zip_code: _address?.zip_code ?? '',
      photo,
    };

    register(removeEmpty(args), () => {
      history.push({
        pathname: '/',
        state: {
          is_new_registerd: true,
        },
      });
    });
  };

  return (
    <>
      <PageTitle title="Review Details | Manila E-Citizen" />
      <div className="space-y-8">
        <div className="card rounded-lg space-y-6">
          {editReturnLink(
            'Edit Personal Information',
            onClick('/register/personal')
          )}
          <DetailsView data={personal} />
        </div>
        <div className="card rounded-lg space-y-6">
          {editReturnLink('Edit Address', onClick('/register/address'))}
          <DetailsView data={address} />
        </div>
        <div className="card rounded-lg space-y-6">
          {editReturnLink('Edit Photo', onClick('/register/take-photo'))}
          <div className="flex justify-center">
            <img
              src={photo || 'http://placehold.jp/250x300.jpg'}
              alt=""
              className="object-contain"
            />
          </div>
        </div>
        <Button
          label="Register Now"
          onClick={handleOnRegister}
          isLoading={isRegisterApiLoading}
          className="btn primary md font-base text-sm"
        />
      </div>
    </>
  );
}
ReviewDetails.defaultProps = {};

ReviewDetails.propTypes = {};

export default ReviewDetails;
